import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import NotificationApi from '../server/NotificationApi';

export default {

    getAll: () => {
        const types = {
            success:    ActionTypes.NOTIFICATION_LIST,
            failure:    ActionTypes.NOTIFICATION_LIST_ERROR
        };
        return CentricDispatcher.dispatchAsync(NotificationApi.getAll(), types);
    },

    markAsRead: (id) => {
        const types = {
            success:    ActionTypes.NOTIFICATION_INFO,
            failure:    ActionTypes.NOTIFICATION_INFO_ERROR
        };
        return CentricDispatcher.dispatchAsync(NotificationApi.markAsRead(id), types, {id});

    }
};
